<template lang="pug">
swiper.lobby-swiper(:options="swiperOptions")
  //- swiper-slide
  //-   a(:href="cny" title='Youtube' target="youtube" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
  //-     img.img-fluid.w-100(:src="'/images/slider/cny22_1000x333_v3.jpg'")
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/thaipusam24_1000x333.jpg'")
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/cny24_1000x333.jpg'")
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/australia_open_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/australia_open_1000x333.jpg'") 
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/championship_league_2024_group3_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/championship_league_2024_group3_1000x333.jpg'") 
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/welsh_open_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/welsh_open_1000x333.jpg'")
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/thailand_master_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/thailand_master_1000x333.jpg'")
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/tournament_prize_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/tournament_prize_1000x333.jpg'")  
  //- fixed sliders rarely change
  swiper-slide
    template(v-if="language == 'cn'")
      img.img-fluid.w-100(:src="'/images/slider/street_fighter6_v3_1000x333_cn.jpg'")
    template(v-else)
      img.img-fluid.w-100(:src="'/images/slider/street_fighter6_v3_1000x333.jpg'")
  swiper-slide(v-if="esports2")
    img.img-fluid.w-100(:src="'/images/slider/tf_gaming_' + language + '.jpg'")
  swiper-slide
    a(:href="kof" title='Youtube' target="youtube" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
      img.img-fluid.w-100(:src="'/images/slider/kof_ufc3_mk11_1000x333_' + language + '.jpg'")
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/racing_' + language + '.jpg'")
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/yeebet_1000x333_' + language + '.jpg'")
  swiper-slide(v-if="!brand && !thaiBrand")
    img.img-fluid.w-100(:src="'/images/slider/4d_v6_1000x333_' + language + '.jpg'")
  swiper-slide(v-if="!mmoMode")
    template(v-if="!brand")
      img.img-fluid.w-100(:src="'/images/slider/vegas_suit_1000x333_' + language + '.jpg'")
    template(v-else)
      img.img-fluid.w-100(src='/images/slider/vegas_suit_1000x333_cn_gs.jpg')
  swiper-slide(v-if="!mmoMode")
    img.img-fluid.w-100(:src="'/images/slider/phnom_penh_suite_' + language + '.jpg'")
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/hanoi_suite_' + language + '.jpg'")
  //- swiper-slide(v-if="!brand")
  //-   img.img-fluid.w-100(src='/images/slider/new_winningft.jpg')
  //- swiper-slide(v-if="!brand")
  //-   a(:href="youtube" title='Youtube' target="youtube" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
  //-     img.img-fluid.w-100(src='/images/slider/video_banner.jpg')
  swiper-slide
    img.img-fluid.w-100(:src="'/images/slider/bangkok_suite_' + language + '.jpg'")
  .swiper-pagination(slot="pagination")
</template>

<script>
import config from "@/config";

export default {
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    esports2() {
      return config.esports2 == "1";
    },
    brand() {
      return config.brand == "IBCBET";
    },
    thaiBrand() {
      return config.brand == "UBETT";
    },
    youtube() {
      return config.youtubeLink;
    },
    kof() {
      return config.kofLink;
    },
    cny() {
      return config.cnyLink;
    },
    language() {
      if (["id", "kr"].includes(this.$store.getters.language)) {
        return "en";
      } else {
        return this.$store.getters.language;
      }
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    }
  }
};
</script>
